import { render, staticRenderFns } from "./IconSettingsInvoice.vue?vue&type=template&id=616872b4&"
import script from "./IconSettingsInvoice.vue?vue&type=script&lang=js&"
export * from "./IconSettingsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616872b4')) {
      api.createRecord('616872b4', component.options)
    } else {
      api.reload('616872b4', component.options)
    }
    module.hot.accept("./IconSettingsInvoice.vue?vue&type=template&id=616872b4&", function () {
      api.rerender('616872b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsInvoice.vue"
export default component.exports